module.exports = __webpack_public_path__ + "img/3_156.d4c71a98.png";